<template>
   <v-row dense>
      <v-col cols="12" sm="12">
        <v-card
          class="pa-0 rounded-0 elevation-0 pt-6"
          :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
        >
          <v-sheet
            class="transactionTable ib-commission-table"
            :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'"
          >
            <v-data-table
              :headers="headers"
              :items-per-page="5"
              :items="mt5AllTransactions"
            >
                <template v-slot:item.created_at="{ item }">
                    {{ new Date(item.created_at).toLocaleString() }}
                </template>
                <template v-slot:item.updated_at="{ item }">
                    {{ new Date(item.updated_at).toLocaleString() }}
                </template>
                <template v-slot:item.status="{ item }">
                    <span :style="getColor(item.status)">{{ item.status }}</span>
                </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { TRADEMASTER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Id", align: "start", value: "id" },
        { text: "Acc. No", value: "acc_no" },
        { text: "Amount", value: "amount" },
        { text: "Net Amount", value: "net_amount" },
        { text: "Transaction Fee", value: "transaction_fee" },
        { text: "Trx. Type", value: "trx_type" },
        { text: "Trx.Status", value: "status" },
        { text: "Created At", value: "created_at" },
        { text: "Updated At", value: "updated_at" },
      ],
    };
  },

  computed: {
    ...mapState("tradeMaster", ["mt5AllTransactions"]),
  },

  methods: {
    ...mapActions("tradeMaster", [TRADEMASTER__ACTIONS.MT5TRANSACTIONS]),

    getColor(status) {
      if (status === "Approved")
        return "color: #039de9";
      else if (status === "Decline") return "color: red";
      else return "color: yellow";
    },
  },

  async mounted() {
    await this[TRADEMASTER__ACTIONS.MT5TRANSACTIONS](this.$route.params.id);
  },
};
</script>
